// extracted by mini-css-extract-plugin
export default {"variantPicker":"PayeeProduct_variantPicker__Eg+v3"};